import {
  Component,
  inject,
  Injector,
  Input,
  OnInit,
  output,
  input,
  viewChild
} from '@angular/core';
import { idNameItem, jkLib } from 'jk-service';
import {
  JkautocompleteComponent,
  JkBaseComponent,
  JkComboboxComponent,
} from 'jk-service';
import {
  stklg002List,
  StklgRange,
  StklgService,
  stockRangeList,
} from '../../services/stklg.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ScreenCaptureService } from 'jk-service';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexStroke,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexXAxis,
  ChartComponent,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { MaterialModule } from 'jk-service';
import { VolumeChartComponent } from '../volume-chart/volume-chart.component';
import { KdChartComponent } from '../kd-chart/kd-chart.component';
import { MacdChartComponent } from '../macd-chart/macd-chart.component';
import { StockService } from '../../services/stock.service';
import { JackBaseComponentModule } from 'jk-service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { StkmaService } from '../../_service_stk';
import { StockView01Component } from '../../stock-view01/stock-view01.component';
import { StockData } from '../../services/stockBase';

// ChartOptions 不要共用,各自定義
type ChartOptions = {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  title: ApexTitleSubtitle;
  plotOptions: ApexPlotOptions;
  stroke: ApexStroke;
  tooltip: ApexTooltip;
  //dataLabels?: ApexDataLabels;
  //legend?: ApexLegend;
  //grid?: ApexGrid;
};

//let bbchartCom: JkbbchartComponent;

@Component({
  standalone: true,
  selector: 'app-jkbbchart',
  templateUrl: './jkbbchart.component.html',
  styleUrls: ['./jkbbchart.component.scss'],
  imports: [
    MaterialModule,
    JackBaseComponentModule,

    NgApexchartsModule,
    //RouterOutlet,
    StockView01Component,
    VolumeChartComponent,
    KdChartComponent,
    MacdChartComponent,
  ],
})
export class JkbbchartComponent extends JkBaseComponent implements OnInit {
  injector = inject(Injector);
  capture = inject(ScreenCaptureService);

  readonly chart = viewChild.required<ChartComponent>('chart');
  readonly kdchart = viewChild.required<KdChartComponent>('kdchart');
  readonly macdchart = viewChild.required<MacdChartComponent>('macdchart');
  readonly volumechart = viewChild.required<VolumeChartComponent>('volumechart');

  plotOptions: ApexPlotOptions = {
    candlestick: {
      colors: {
        upward: 'red', //'#3C90EB',
        downward: 'black', //'#DF7D46',
      },
      wick: {
        useFillColor: true,
      },
    },
  };
  candleList: any[] = [];
  sma5List: any[] = [];
  sma20List: any[] = [];
  volumeList: any[] = [];
  sma60List: any[] = [];
  smaBBUpperList: any[] = [];
  smaBBLowerList: any[] = [];

  //series2 = {data:[]};
  series2: ApexAxisChartSeries = [{ name: 'volume', data: this.candleList }];
  setAnimations() {
    return {
      enabled: false,
      //easing: 'easeinout',
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150,
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350,
      },
    };
  }
  setSeries() {
    return [
      {
        name: '日K線',
        type: 'candlestick',
        id: 'candles',
        data: this.candleList,
      },
      {
        name: 'sma5',
        type: 'line',
        color: '#008000', // green
        data: this.sma5List,
      },
      {
        name: 'sma20',
        type: 'line',
        color: '#FFA500', // 橙色（Orange）：#FFA500
        data: this.sma20List,
      },
      {
        name: 'sma60',
        type: 'line',
        color: '#FF0000', // 紅色（Red）：#FF0000
        data: this.sma60List,
      },
      {
        name: 'BB上軌',
        type: 'line',
        color: '#3C90EB', // 紫色
        data: this.smaBBUpperList,
      },
      {
        name: 'BB下軌',
        type: 'line',
        color: '#3C90EB',
        data: this.smaBBLowerList,
      },
    ];
  }
  chartOpt: ApexChart = this.getApexChart();
  XList: string[] = [];
  chartOptions: ChartOptions = {
    plotOptions: this.plotOptions,
    chart: this.chartOpt,
    title: {
      text: this.label() + ' 技術線圖',
      align: 'left',
    },
    series: this.setSeries(), //this.series2,
    xaxis: {
      type: 'category', // datetime","numeric"
      categories: this.XList,
    },
    stroke: { width: [1, 1] },
    tooltip: {
      shared: true,
      custom: [
        //function ({ seriesIndex, dataPointIndex, w }) {
        //bbchartCom.updateStockData(dataPointIndex );
        ({ seriesIndex, dataPointIndex, w }) => {
          this.updateStockData(dataPointIndex);
          const o = w.globals.seriesCandleO[seriesIndex][dataPointIndex];
          const h = w.globals.seriesCandleH[seriesIndex][dataPointIndex];
          const l = w.globals.seriesCandleL[seriesIndex][dataPointIndex];
          const c = w.globals.seriesCandleC[seriesIndex][dataPointIndex];
          return (
            '<div class="apexcharts-tooltip-candlestick">' +
            '<div>開盤: <span class="value">' +
            o +
            '</span></div>' +
            '<div>最高: <span class="value">' +
            h +
            '</span></div>' +
            '<div>最低: <span class="value">' +
            l +
            '</span></div>' +
            '<div>收盤: <span class="value">' +
            c +
            '</span></div>' +
            '</div>'
          );
        },
        ({ seriesIndex, dataPointIndex, w }) => {
          this.updateStockData(dataPointIndex);
          return w.globals.series[seriesIndex][dataPointIndex];
        },
        ({ seriesIndex, dataPointIndex, w }) => {
          this.updateStockData(dataPointIndex);
          return w.globals.series[seriesIndex][dataPointIndex];
        },
        ({ seriesIndex, dataPointIndex, w }) => {
          this.updateStockData(dataPointIndex);
          return w.globals.series[seriesIndex][dataPointIndex];
        },
        ({ seriesIndex, dataPointIndex, w }) => {
          this.updateStockData(dataPointIndex);
          return w.globals.series[seriesIndex][dataPointIndex];
        },
        ({ seriesIndex, dataPointIndex, w }) => {
          this.updateStockData(dataPointIndex);
          return w.globals.series[seriesIndex][dataPointIndex];
        },
      ],
    },
  }; // Partial<ChartOptions> ;

  doScreenCapture() {
    this.capture.screenCapture('bbchart', jkLib.nowTime8() + '_bbchart.png');
  }
  //@ViewChild('marquee') marquee: MarqueeComponent;
  readonly view1 = viewChild.required<StockView01Component>('view1');
  _itemList: any[] = [];
  stockData: StockData = new StockData();
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set itemList(value) {
    if (!value) return;
    this._itemList = value;
    if (this._itemList.length > 0) {
      this.label.set(
        this._itemList[0].stockName + `(${this._itemList[0].stockno})`);
    }
    this.trans2candleList(value);
    //this.marqeeFontSize(0);

    //this.calcMessage1(value[value.length-1]);
    //this.calcMessage2(value[value.length-1]);
  }
  get itemList() {
    return this._itemList;
  }
  readonly scrollbarVisible = input(true);
  readonly open = input<string>('open'); // 開盤欄位
  readonly high = input<string>('high'); // 最高欄位
  readonly low = input<string>('low'); // 最低欄位
  readonly close = input<string>('close'); // 收盤欄位
  readonly UBT = input<string>('UBT'); // BB上軌欄位
  readonly LBT = input<string>('LBT'); // BB下軌欄位
  readonly X = input<string>('X'); // X軸欄位
  readonly sma5 = input<string>('sma5'); // 5日均線欄位
  //@Input() sma10:string = 'sma10'; // 10日均線欄位
  readonly sma20 = input<string>('sma20'); // 20日均線欄位
  readonly sma60 = input<string>('sma60'); // 60日均線欄位
  readonly qty = input<string>('qty'); // 成交量欄位
  //@Input() tickInterval: number = 50;
  readonly visualRange = input<any>({});
  readonly barGroupWidth = input<number>(4); //no use
  htmlMessage1?: SafeHtml; // string = '<p>htmlmessage未設定</p>';
  message2: string = 'message未設定';
  customizeText = (arg: any) => `${arg.valueText}&#176F`;
  readonly stopProfit = input<number>(0); // 停利
  readonly stopLoss = input<number>(0); // 停損
  readonly sustain = input<number>(0); // 支撐
  readonly pressure = input<number>(0); // 壓力
  chartBarOptions: any = {};
  protected sanitizer: DomSanitizer;
  constructor() {
    super();
    const injector = this.injector;

    //bbchartCom = this;
    this.updateStockData.bind(this); // 20241219 add
    this.sanitizer = injector.get(DomSanitizer);
    //this = this;
    //this.customizeTooltip.bind(this);
    //this.updateMessage.bind(this);
    //this.calcMessage2.bind(this);
    this.initChart();
  }
  initChart() {
    this.chartBarOptions = {
      series: [
        {
          name: 'volume',
          data: this.volumeList,
        },
      ],
      chart: {
        height: 160,
        type: 'bar',
        brush: {
          enabled: true,
          target: 'candles',
        },
        selection: {
          enabled: true,
          xaxis: {
            min: new Date('20 Jan 2017').getTime(),
            max: new Date('10 Dec 2017').getTime(),
          },
          fill: {
            color: '#ccc',
            opacity: 0.4,
          },
          stroke: {
            color: '#0D47A1',
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: '80%',
          colors: {
            ranges: [
              {
                from: -1000,
                to: 0,
                color: '#F15B46',
              },
              {
                from: 1,
                to: 10000,
                color: '#FEB019',
              },
            ],
          },
        },
      },
      stroke: {
        width: 0,
      },
      xaxis: {
        type: 'category',
        axisBorder: {
          offsetX: 13,
        },
      },
      yaxis: {
        labels: {
          show: false,
        },
      },
    };
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();

    /*if (!this.stockSrv) {
      this.stockSrv = new StockService();
    }
    if (!this.stklgSrv) {
      this.stklgSrv = new StklgService();
    }
    if (!this.stkmaSrv) {
      this.stkmaSrv = new StkmaService();
    }*/
  }

  updateStockData(index: number) {
    this.stockData.importStklgV02(this.itemList[index]);
  }
  /*
  calcMessage2(data: any, format: number = 1): string {
    if (!data) return '';
    let s = JSON.stringify(data);
    this.message2 = s;
    return s;
  }

  customizeTooltip(arg: any) {
    let ret = '';
    try {
      const d = arg.argument;
      const data = arg.point.data;
      this.stockData.importStklgV02(data);
      const s = jkLib.date2Display(d, '/');
      ret =
        arg.seriesName +
        ': ' +
        arg.valueText +
        '<br/>' +
        '日期: ' +
        s +
        '<br/>' +
        //'開盤: ' + data.open + '<br/>' +
        '收盤: ' +
        data.close +
        '<br/>';
      //'最高: ' + data.high + '<br/>' +
      //'最低: ' + data.low + '<br/>'+
      //'上軌: ' + data.UBT + '<br/>'+
      //'下軌: ' + data.LBT + '<br/>'+
      //'sma20: ' + data.sma20 + '<br/>'+
      //'sma60: ' + data.sma60 + '<br/>'
      // = arg.seriesName + ': ' + arg.valueText +
      //'日期: ' + s +
      //if(parent.marquee){
      //  parent.marquee.message1 = '振幅%:'+data.LG022+',漲跌幅%:'+data.LG023;
      //}
    } catch (error) {
      console.log('error:', error);
    }
    this.updateMessage(this.stockData);
    return {
      text: ret,
    };
  }

  updateMessage(data: StockData) {
    let html = this.stklg.DrawHtml(data, 1);
    let h = this.sanitizer.bypassSecurityTrustHtml(html);

    this.htmlMessage1 = h;
    this.calcMessage2(data);
  }
  */
  trans2candleList(value: any[]) {
    this.candleList = []; // { x: new Date(2017, 10, 1), y: [62.89, 63.42, 59.72, 61.76] },
    this.sma5List = [];
    this.sma20List = [];
    this.volumeList = [];
    this.sma60List = [];
    this.smaBBUpperList = [];
    this.smaBBLowerList = [];
    this.XList = [];
    if (value.length === 0) return;
    this.stockData.importStklgV02(value[value.length - 1]);

    value.forEach((v) => {
      this.XList.push(v['date1']);
      let d = v['date1']; // new Date(v[this.X]);
      let x = parseFloat(v[this.X()]);
      let o = parseFloat(v[this.open()]);
      let h = parseFloat(v[this.high()]);
      let l = parseFloat(v[this.low()]);
      let c = parseFloat(v[this.close()]);
      let b = [d, o, h, l, c];
      let kb = { x: d, y: [o, h, l, c] };
      this.candleList.push(kb);
      this.sma5List.push({ x: d, y: parseFloat(v[this.sma5()]) });
      this.sma20List.push({ x: d, y: parseFloat(v[this.sma20()]) });
      this.volumeList.push({ x: d, y: parseFloat(v[this.qty()]) });
      this.sma60List.push({ x: d, y: parseFloat(v[this.sma60()]) });
      this.smaBBUpperList.push({ x: d, y: parseFloat(v[this.UBT()]) });
      this.smaBBLowerList.push({ x: d, y: parseFloat(v[this.LBT()]) });
    });
    //this.series2[0].data = this.candleList;
    //console.log(this.chartOptions.series);
    this.chartOptions.series = this.setSeries(); // [{ data: this.candleList }]; // this.series2;
    this.chartOptions.chart.animations = this.setAnimations();
    this.chartOptions.title = this.getTitle();
    //console.log(this.chartOptions.series);
  }
  getTitle(): any {
    //if(this.itemList.length === 0) return '';
    //this.title = this.itemList[0].stockName;
    return {
      text: this.label() + ' 技術線圖',
      align: 'left',
    };
  }
  doTest1() {
    throw new Error('Method not implemented.');
  }
  doTest2() {
    throw new Error('Method not implemented.');
  }
  getApexChart(): ApexChart {
    let chart: ApexChart = {
      height: 350,
      type: 'candlestick',
      animations: this.setAnimations(),
      background: '#fff',
      defaultLocale: 'zh-tw',
      locales: [
        {
          name: 'zh-tw',
          options: {
            months: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月',
            ],
            shortMonths: [
              '一月',
              '二月',
              '三月',
              '四月',
              '五月',
              '六月',
              '七月',
              '八月',
              '九月',
              '十月',
              '十一月',
              '十二月',
            ],
            days: [
              '星期日',
              '星期一',
              '星期二',
              '星期三',
              '星期四',
              '星期五',
              '星期六',
            ],
            shortDays: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
            toolbar: {
              exportToSVG: '下載 SVG',
              exportToPNG: '下載 PNG',
              exportToCSV: '下載 CSV',
              menu: '菜單',
              selection: '選擇',
              selectionZoom: '選擇縮放',
              zoomIn: '放大',
              zoomOut: '縮小',
              pan: '平移',
              reset: '重置縮放',
            },
          },
        },
        {
          name: 'en',
          options: {
            months: [
              'January',
              'February',
              'March',
              'April',
              'May',
              'June',
              'July',
              'August',
              'September',
              'October',
              'November',
              'December',
            ],
            shortMonths: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec',
            ],
            days: [
              'Sunday',
              'Monday',
              'Tuesday',
              'Wednesday',
              'Thursday',
              'Friday',
              'Saturday',
            ],
            shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            toolbar: {
              exportToSVG: 'Download SVG',
              exportToPNG: 'Download PNG',
              exportToCSV: 'Download CSV',
              menu: 'Menu',
              selection: 'Selection',
              selectionZoom: 'Selection Zoom',
              zoomIn: 'Zoom In',
              zoomOut: 'Zoom Out',
              pan: 'Panning',
              reset: 'Reset Zoom',
            },
          },
        },
      ],
    };
    return chart;
  }
  /*
  marqeeFontSize(n: number) {
    if (this.marquee) {
      let size = this.marquee.marqueeSize;
      //let s = document.getElementById('marqee').style.fontSize;
      //size = parseInt(s);
      size = size + n;
      this.marquee.marqueeSize = size;
      //document.getElementById('marqee').style.fontSize = size.toString()+'px';
    }
  }*/
  readonly stklg002Com = viewChild.required<JkComboboxComponent>('stklg002Com');
  readonly stklg004Com = viewChild.required<JkautocompleteComponent>('stklg004Com');
  readonly afterGridReadyStockKLine = output<string>();
  //_stockSrv!: StockService;
  _stockSrv: StockService = inject(StockService);
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set stockSrv(value: StockService) {
    this._stockSrv = value;
  }
  get stockSrv(): StockService {
    return this._stockSrv;
  }
  //_StklgSrv!: StklgService;
  _StklgSrv: StklgService = inject(StklgService);
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set stklgSrv(value: StklgService) {
    this._StklgSrv = value;
  }
  get stklgSrv(): StklgService {
    return this._StklgSrv;
  }
  //_stkmaSrv!: StkmaService;
  _stkmaSrv: StkmaService = inject(StkmaService);
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set stkmaSrv(value: StkmaService) {
    this._stkmaSrv = value;
  }
  get stkmaSrv(): StkmaService {
    return this._stkmaSrv;
  }
  get stkmaIdNameList(): any[] {
    if (!this.stkmaSrv) return [];
    return this.stkmaSrv.idNameList;
  }
  stklg002List = stklg002List;
  /*get stklg002List(): any[] {
    if(!this.stockSrv) return [];
    return this.stockSrv.stklg002List;
  }*/
  get stklg002(): string {
    if (!this.stockSrv) return '日線';
    return this.stockSrv.stklg002;
  }
  set stklg002(value: string) {
    if (!this.stockSrv) return;
    this.stockSrv.stklg002 = value;
  }
  /*get stockRangeList(): any[] {
    if(!this.stockSrv) return [];
    return this.stockSrv.stockRangeList;
  }*/
  stockRangeList = stockRangeList;
  get stklgList(): any[] {
    if (!this.stklgSrv) return [];
    return this.stklgSrv.itemList();
  }
  get stockRange(): string {
    if (!this.stockSrv) return '60';
    return this.stockSrv.stockRange;
  }
  set stockRange(value: string) {
    if (!this.stockSrv) return;
    this.stockSrv.stockRange = value;
  }

  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input()
  get stockno(): string {
    if (this.stockSrv) return this.stockSrv.stockNo;
    else return '';
  }
  set stockno(value: string) {
    if (this.stockSrv) {
      this.stockSrv.stockNo = value;
      this.changeStockById(value);
    }
  }

  changeStockById(id: string) {
    if (!this.stkmaSrv) return;
    this.stkmaSrv.gotoKey(id);
    this.changeStock(this.stkmaSrv.item);
  }
  changeStock(item: any) {
    if (!item) return;
    this.stockSrv.stockNo = item.id;
    this.stkmaSrv.gotoKey(this.stockno);
    this.doQueryStklg('');
  }
  async doQueryStklg(message: string) {
    if (!this.stockno) return;
    let jsonObj = undefined;
    if (message.substring(0, 1) === '{') {
      jsonObj = JSON.parse(message);
    }
    let r: StklgRange = {
      rangeId: this.stockSrv.stockRange,
      stockNos: this.stockSrv.stockNo,
      date1: this.stockSrv.date1,
      date2: this.stockSrv.date2,
      time1: '',
      time2: jkLib.nowTime4(),
      period: this.stockSrv.stklg002,
      topN: 0,
    };
    await this.stklgSrv.calcStklgRange(r); // FIXME: 設 TopN
    let where = ''; // this.stklgSrv.sqlWhereDefault;
    try {
      //where = this.stklg001.addWhere(where, 'LG001');
      where = ` AND LG001>='${this.stockSrv.date1}' AND LG001<='${this.stockSrv.date2}' `;
      where = this.stklg002Com().addWhere(where, 'LG002');
      const stklg004Com = this.stklg004Com();
      if (stklg004Com.value !== this.stockno)
        stklg004Com.value = this.stockno;
      where = stklg004Com.addWhere(where, 'LG004');
      //where = this.stkma019.addWhere(where, 'MA019');
    } catch (error: any) {
      alert('doQuery:' + error.message);
      return;
    }
    this.orm
      .doOpenWin_post('S', 'STKLG', 'V02', [], where, '')
      .subscribe((data: any) => {
        if (data.result) {
          this.stklgSrv.setItemList(data.obj);
          //this.updateChart();
          this.kindValueChange(this.kind);

        }
      });
  }
  updateChart() {
    if (!this.stklgSrv) return;
    if (this.stklgSrv.itemList.length > 0) {
      this.itemList = this.stklgSrv.itemList();
      this.stockData.importStklgV02(
        this.itemList[this.stklgSrv.itemList().length - 1]
      );
      this.stklgSrv.setItemList(this.itemList);
      /*
      this.kdchart.itemList = this.stklgSrv.itemList;
      //this.kdchart.refresh();
      this.macdchart.itemList = this.stklgSrv.itemList;
      //this.macdchart.refresh();
      this.volumechart.itemList = this.stklgSrv.itemList;
      this.volumechart.setChartOptions();
      */
    }
  }
  kindList: idNameItem[] = [
    { id: 'view01', name: '明細' },
    { id: 'volume', name: '成交量' },
    { id: 'kd', name: 'KD' },
    { id: 'macd', name: 'Macd' },
  ];
  kind: string = this.kindList[0].id;
  _kindIndex: number = 0;
  get kindIndex(): number {
    return this._kindIndex;
  }
  set kindIndex(value: number) {
    this._kindIndex = value;
    this.kind = this.kindList[value].id;
    this.kindValueChange(this.kind);
  }
  view01Visible: boolean = true;
  volumeVisible: boolean = false;
  kdVisible: boolean = false;
  macdVisible: boolean = false;
  onKindTabChange($event: MatTabChangeEvent) {
    this.kindValueChange(this.kindList[$event.index].id);
  }

  kindValueChange($event: string) {
    this.allOptionHide();
    let delayTime = 500;
    if ($event === 'view01') {
      this.view01Visible = true;
      this.updateChart();
    }
    if ($event === 'volume') {
      this.volumeVisible = true;
      setTimeout(() => {
        this.volumechart().itemList = this.stklgSrv.itemList();
        this.volumechart().setChartOptions();
        this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
      }, delayTime);
    }
    if ($event === 'kd') {
      this.kdVisible = true;
      setTimeout(() => {
        this.kdchart().itemList = this.stklgSrv.itemList();
        this.kdchart().refresh();
        this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
      }, delayTime);
    }
    if ($event === 'macd') {
      this.macdVisible = true;
      setTimeout(() => {
        this.macdchart().itemList = this.stklgSrv.itemList();
        this.macdchart().refresh();
        this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
      }, delayTime);
    }
  }
  allOptionHide() {
    this.view01Visible = false;
    this.volumeVisible = false;
    this.kdVisible = false;
    this.macdVisible = false;
  }
}
